import {AfterViewInit, Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {RelatedProductList} from "../../product-details/interface/related-product-list";
import {ObserveBreakpointService} from "../../observe-breakpoint.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
	selector: 'fb-product-variant',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './product-variant.component.html',
	styleUrls: ['./product-variant.component.scss']
})
export class ProductVariantComponent implements AfterViewInit {

	public viewableRelatedList: RelatedProductList[] = [];
	@Input() productSku: string = '';
	@Input() public relatedList: RelatedProductList[] = [];
	@Input() public productCategory: string = '';
	public showMore: boolean = false;
	protected viewableItems: number = 4;

	constructor(
		private _breakpointService: ObserveBreakpointService
	) {
	}

	ngAfterViewInit() {
		this._breakpointService.observe('lg')
			.pipe(untilDestroyed(this))
			.subscribe((isMd) => {
				if (isMd) {
					this.viewableItems = 7;
				}
				else {
					this.viewableItems = 4;
				}
			});

		if(this.relatedList.length > (this.viewableItems + 1)) {
			this.viewableRelatedList = this.relatedList.slice(0, this.viewableItems);
		}
		else {
			this.viewableRelatedList = this.relatedList;
		}
		this.showMore = false;
	}

	public toggleView(): void {
		this.showMore = !this.showMore;
		if(this.showMore) {
			this.viewableRelatedList = this.relatedList;
		}
		else  {
			this.viewableRelatedList = this.relatedList.slice(0, this.viewableItems);
		}
	}
}
